var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Stack } from "@mui/material";
import { MessageHeader } from "./Molecules";
import { COLORS } from "../../../constants";
var MessageContainer = function (_a) {
    var _b = _a.bgColor, bgColor = _b === void 0 ? "linear-gradient( ".concat(COLORS.ICE_BLUE, ", ").concat(COLORS.WHITE, ")") : _b, children = _a.children, header = _a.header, title = _a.title, logoUrl = _a.logoUrl, _c = _a.width, width = _c === void 0 ? [327, 496] : _c, _d = _a.heightOffset, heightOffset = _d === void 0 ? "48px" : _d;
    return (_jsx(Stack, __assign({ sx: { background: bgColor, minHeight: "calc(100vh - ".concat(heightOffset, ")") }, direction: "column", p: 6, alignItems: "center", justifyContent: "center" }, { children: _jsxs(Paper, __assign({ sx: {
                width: "100%",
                maxWidth: width,
                pb: 12,
                pt: header ? 0 : 12,
            }, elevation: 2 }, { children: [header && _jsx(MessageHeader, { title: title, logoUrl: logoUrl }), children] })) })));
};
export default MessageContainer;
